/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue';
import Vuex from 'vuex';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

// fontwesome
import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {faTwitter} from '@fortawesome/free-brands-svg-icons'
import {
    faGear,
    faMagnifyingGlass,
    faPenToSquare,
    faPlus,
    faTrashCan,
    faUserSecret,
    faCheck
} from '@fortawesome/free-solid-svg-icons'


window.Vue = require('vue').default;

Vue.use(Vuex);

Vue.component('v-select', vSelect)

// fontwesome
library.add(faUserSecret, faMagnifyingGlass, faTwitter,
    faPlus, faPenToSquare, faTrashCan, faGear, faCheck)
Vue.component('font-awesome-icon', FontAwesomeIcon)



const store = new Vuex.Store({
    state: {
        item: {},
        errorMessageResponse : null,
        transaction : { status : '', message : '', data : ''}
    },
})


Vue.use(VueCustomTooltip, {
    background: '#f05737',
})


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//pages components
Vue.component('example-component', require('./vue/components/ExampleComponent.vue').default);
Vue.component('login-component', require('./vue/pages/auth/login/Login.vue').default);
Vue.component('register-component', require('./vue/pages/auth/login/RegisterComponent.vue').default);
Vue.component('email-component', require('./vue/pages/auth/login/passwords/EmailComponent').default);
Vue.component('daily-menu-component', require('./vue/pages/DailyMenyComponent').default);
Vue.component('order-customer-employees-confirm-resgister-component', require('./vue/pages/OrderCustomerEmployeesConfirmResgister').default);
Vue.component('order-customer-employees-component', require('./vue/pages/OrderCustommerEmployees').default);
Vue.component('order-customer-employees-finish-component', require('./vue/pages/OrderCustomerEmployeesFinish').default);
Vue.component('report-order-customer-daily-component', require('./vue/pages/ReportOrderCustomerDaily').default);

//components
Vue.component('alert-error-message-component', require('./vue/components/AlertErrorMessagesComponent.vue').default);
Vue.component('connection-api-test-component', require('./vue/components/ConnectionApiTestComponent').default);
Vue.component('menu-component', require('./vue/components/MenuKitComponent').default);
Vue.component('alert-component', require('./vue/components/AlertComponent').default);
Vue.component('loader-component', require('./vue/components/LoaderComponent').default);
Vue.component('breadcrumb-component', require('./vue/components/BreadCrumbComponent').default);
Vue.component('card-component', require('./vue/components/CardComponent').default);
Vue.component('table-component', require('./vue/components/TableComponent').default);
Vue.component('confirm-modal-component', require('./vue/components/ConfirmModalComponent').default);
Vue.component('footer-component', require('./vue/components/Footer').default);



/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


Vue.prototype.getErrorMessage = function (error, errorCode){
    if(error.code  === errorCode){
        this.$store.state.errorMessageResponse = error.message;
    }else{
        this.$store.state.errorMessageResponse  = null;
    }
}

Vue.prototype.inputOnlyNumbers = function (element){
    $(element).keypress(function (e) {
        let charCode = (e.which) ? e.which : event.keyCode
        if (String.fromCharCode(charCode).match(/[^0-9]/g))
            return false;
    });
}


Vue.prototype.isEmail = function (email) {
    var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!regex.test(email)) {
        return false;
    } else {
        return true;
    }
}

Vue.prototype.formateDateBR = function (d) {
    if(!d) return ''

    //formatando a data
    let date = d.split('-')
    return date[2] + '/' + date[1] + '/' + date[0]
}


Vue.filter('formateGlobalDateTime', function(d) {
    if(!d) return ''

    d = d.split('T')

    let date = d[0]
    let time = d[1]

    //formatando a data
    date = date.split('-')
    date = date[2] + '/' + date[1] + '/' + date[0]

    //formatar o tempo
    time = time.split('.')
    time = time[0]

    return date + ' ' + time
})


Vue.filter('formateGlobalDate', function(d) {
    if(!d) return ''

    //formatando a data
    let date = d.split('-')
    return date[2] + '/' + date[1] + '/' + date[0]
})

Vue.filter('dateWeekName', function(d) {
    let weekName = ["Segunda-Feira", "Terça-Feira", "Quarta-Feira", "Quinta-Feira", "Sexta-Feira", "Sábado", "Domingo"];
    let dt = new Date(d);
    console.log(dt.getDay())
    return weekName[dt.getDay()];

})


const app = new Vue({
    el: '#app',
    store,
});
